import classNames from 'classnames';

import Card from '../../../components/Card';
import { EbookSubmissionFragment } from '../../../core/graphql/types';
import { getDayTime } from '../../../utils/dayjs';
import { EBOOK_SUBMISSION_STATUS_CLASS_NAME, EBOOK_SUBMISSION_STATUS_LABEL } from '../constants/status';

const DATE_FORMAT = 'DD-MM-YYYY hh:mm A';

export interface IPropsEbookSubmissionDetailPresenter {
  ebookSubmission?: EbookSubmissionFragment;
}

function EbookSubmissionDetailPresenter(props: IPropsEbookSubmissionDetailPresenter) {
  const { ebookSubmission } = props;

  return (
    <Card className="flex flex-col space-y-16">
      <div className="text-22">Detail</div>

      <div className="flex space-x-24">
        <div className="flex w-[200px] font-tt">Status</div>
        <div>
          {ebookSubmission?.status && (
            <div className={classNames(EBOOK_SUBMISSION_STATUS_CLASS_NAME[ebookSubmission.status])}>{EBOOK_SUBMISSION_STATUS_LABEL[ebookSubmission.status]}</div>
          )}
        </div>
      </div>

      <div className="flex space-x-24">
        <div className="flex w-[200px] font-tt">File name</div>
        <div className="break-all">{ebookSubmission?.fileName || '-'}</div>
      </div>

      <div className="flex space-x-24">
        <div className="flex w-[200px] font-tt">File</div>
        <div>
          {ebookSubmission?.fileUrl ? (
            <a href={ebookSubmission.fileUrl} target="_blank" rel="noreferrer" className="underline text-colorsBrandRed01Primary">
              Download
            </a>
          ) : (
            '-'
          )}
        </div>
      </div>

      <div className="flex space-x-24">
        <div className="flex w-[200px] font-tt">Item count</div>
        <div>{ebookSubmission?.itemCount ?? '-'}</div>
      </div>

      <div className="flex space-x-24">
        <div className="flex w-[200px] font-tt">Uploaded by</div>
        <div>{ebookSubmission?.actor?.username || '-'}</div>
      </div>

      <div className="flex space-x-24">
        <div className="flex w-[200px] font-tt">Admin note</div>
        <div>{ebookSubmission?.adminNote || '-'}</div>
      </div>

      <div className="flex space-x-24">
        <div className="flex w-[200px] font-tt">Created at</div>
        <div>{ebookSubmission?.createdAt ? getDayTime(ebookSubmission.createdAt, DATE_FORMAT) : '-'}</div>
      </div>

      {ebookSubmission?.cancelledAt && (
        <div className="flex space-x-24">
          <div className="flex w-[200px] font-tt">Cancelled at</div>
          <div>{getDayTime(ebookSubmission.cancelledAt, DATE_FORMAT)}</div>
        </div>
      )}
    </Card>
  );
}

export default EbookSubmissionDetailPresenter;
